import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Popconfirm } from 'antd';
import { useDispatch } from 'react-redux';
import { removeServiceById } from '../../../../redux/asyncActions/listService';
import { useLangField } from '../../../../hooks/useLangField';

export const useTableColumnsListService = (listService, onEdit) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const getLangField = useLangField();

  const codeFiltersValue = useMemo(() => {
    const uniqCodes = Array.from(new Set(listService.map((item) => item.code)));
    return uniqCodes.map((code) => ({ text: code, value: code }));
  }, [listService]);

  const nameFiltersValue = useMemo(() => {
    const uniqNames = Array.from(new Set(listService.map((item) => item.name)));
    return uniqNames.map((name) => ({ text: name, value: name }));
  }, [listService]);

  const organizationTypeFiltersValue = useMemo(() => {
    const uniq = new Map();
    listService.forEach(({ orgType }) => {
      if (orgType && !uniq.has(orgType.id)) {
        uniq.set(orgType.id, {
          text: getLangField(orgType, 'name'),
          value: orgType.id,
        });
      }
    });
    return Array.from(uniq.values());
  }, [listService, getLangField]);

  const handleClickEdit = (record) => () => onEdit(record);

  const handleClickDelete = (id) => () => {
    dispatch(removeServiceById(id));
  };

  return [
    {
      title: t('governmentServiceEducation.serviceCode'),
      dataIndex: 'code',
      align: 'center',
      filters: codeFiltersValue,
      onFilter: (value, record) => record.code === value,
      filterSearch: true,
    },
    {
      title: t('governmentServiceEducation.governmentServicesName'),
      dataIndex: 'name',
      align: 'center',
      filters: nameFiltersValue,
      onFilter: (value, record) => record.name === value,
      filterSearch: true,
    },
    {
      title: t('governmentServiceEducation.organizationType'),
      dataIndex: 'organizationType',
      align: 'center',
      render: (_, record) => getLangField(record.orgType, 'name'),
      filters: organizationTypeFiltersValue,
      onFilter: (value, record) => record.orgType.id === value,
      filterSearch: true,
    },
    {
      title: t('governmentServiceEducation.action'),
      key: 'action',
      align: 'center',
      render: (_, record) => {
        return (
          <div>
            <Button type="link" onClick={handleClickEdit(record)}>
              {t('governmentServiceEducation.edit')}
            </Button>
            <Popconfirm
              title={t('warning.WARN01')}
              onConfirm={handleClickDelete(record.id)}
              okText="Да"
              cancelText="Отмена"
            >
              <Button type="link">{t('governmentServiceEducation.delete')}</Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
};
